declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenBool } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-bool',
    templateUrl: './autogenbool.component.html',
    styleUrls: ['./autogenbool.component.scss']
})

export class AutoGenBoolComponent implements OnInit {
    @Input() public mode;
    @Input() public Data: AutoGenBool;
    @Input() public field: FieldData;
    ngOnInit(): void {
    }

    get isChecked(): boolean {
        if (this.field == null || this.field.Value == null) return false;
        const val = String(this.field.Value).trim().toLowerCase();
        return val === 'true' || val === '1' || val === 'yes' || val === 't';
    }

    @Input('isChecked')
    set isChecked(value: boolean) {
        if (this.field != null) {
            if (value)
                this.field.Value = 'True';
            else
                this.field.Value = 'False';
        }
    }
}
